var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},_vm._l((_vm.headList),function(item,i){return _c('div',{key:i,class:[
      'head-item',
      item.highLightList.indexOf(_vm.currPath) != -1 ? 'click-color' : '' ],on:{"click":function($event){return _vm.TabItem(item)}}},[_vm._v("\n    "+_vm._s(item.name)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66f3db4a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = null
// module chunks = 